import type Config from '@panel/config';
import { getCurrentInstance } from 'vue';

export default () => {
  const instance = getCurrentInstance();
  const config = instance.appContext.app.config.globalProperties.$config;

  return config as Config;
};
